import isDev, { isTestEndpoint } from "./isDev";

export const dataLayerPush = (eventData) => {
    if(isDev() || isTestEndpoint()) {
        console.log(eventData);
        return;
    }
    window.dataLayer = window.dataLayer || [];
    /*window.dataLayer &&*/ window.dataLayer.push(eventData);
};
